import { FC, useEffect, useState } from "react";
import "./weekly-per-product-chart.scss";
import { useDispatch, useSelector } from "react-redux";

import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { get } from "http";
import { getICProductConsumptionOverTime } from "../../productSlices";
interface WeeklyPerProductChartProps {
    dates: any;
    }

const processRawData = (rawData, startDate, endDate) => {
    // Helper function to get array of dates between start and end
    const getDatesArray = (start, end) => {
        const dates = [];
        const current = new Date(start);
        const last = new Date(end);
        
        while (current <= last) {
            const year = current.getFullYear();
            const month = String(current.getMonth() + 1).padStart(2, '0');
            const day = String(current.getDate()).padStart(2, '0');
            dates.push(`${year}-${month}-${day}`);
            current.setDate(current.getDate() + 1);
        }
        return dates;
    };
    
    // Get all dates in range
    const allDates = getDatesArray(startDate, endDate);
    
    // Transform raw data into chart format with zeros
    const datasets = rawData.map((product, index) => {
        // Create a map of dates to values for this product
        const productData = {};
        product.points.forEach(point => {
        const dateKey = point.date.split('T')[0];
        productData[dateKey] = point.total_liters;
        });
    
        // Create array of values matching all dates, filling with 0 where no data exists
        const data = allDates.map(date => productData[date] || 0);
    
        return {
        label: product.name,
        data,
        fill: false,
        borderColor: !!index ? '#2BE4D5' : '#4F4BFF', // Generate distinct colors
        backgroundColor: !!index ? '#2BE4D5' : '#4F4BFF',
        tension: 0,
        pointRadius: 5
        };
    });
    
    return {
        labels: allDates,
        datasets
    };
    };

    
const WeeklyPerProductChart: FC<WeeklyPerProductChartProps> = ({dates}) => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const ic_products_over_time = useSelector((state: any) => state.product.ic_product_consumption_over_time);
  const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        if(!dates || !dates[0] || !dates[1]) return
        dispatch(getICProductConsumptionOverTime(selectedShop,dates[0].toDateString().toString(), dates[1].toDateString().toString()))
    },[selectedShop, dates])

    
    useEffect(() => {
        if(!ic_products_over_time) return;
        if(!dates || !dates[0] || !dates[1]) return
        const processedData = processRawData(ic_products_over_time, dates[0].toDateString().toString(), dates[1].toDateString().toString());
       
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    position: 'top',
                align: 'start', 
                labels: {
                    usePointStyle: true, 
                    pointStyle: 'circle', 
                    boxWidth: 10, 
                    padding: 10, 
                }
                },
                customLegendMargin: {
                    id: 'customLegendMargin',
                    beforeDraw: (chart) => {
                        chart.chartArea.bottom += 20; // Adds 20px margin below the legend
                    },
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#696969'
                    },
                    grid: {
                        color: '#696969',
                        display: false
                    }
                },
                y: {
                    ticks: {
                        color: '#696969'
                    },
                    grid: {
                        drawTicks: true, // Keep axis ticks
                        drawOnChartArea: true, // Ensure grid lines appear
                        color: (context) => {
                            // Hide every other grid line
                            return context.index % 3 === 0 ? '#E2E7E7' : undefined;
                        },
                        border:{
                            dash: [5,5]
                        } 
                    }
                }
            }
        };
        setChartData(processedData);
        setChartOptions(options);
    }, [ic_products_over_time]);
 return (
    <div className='weekly-per-product-chart'>
        <Chart type="line" data={chartData} options={chartOptions}  width="75vw" height="30vh"/>
    </div>
  );
};

export default WeeklyPerProductChart;
